import { useWorkspaceContext } from '@/contexts/workspaceContext';

export function useFeatureFlagEnabled(feature: string) {
  const { featureFlags } = useWorkspaceContext();
  const enabled = featureFlags?.find((flag) => flag.feature_name === feature)?.enabled;
  return enabled ?? false;
}
